import "../styles/globals.css";
import React, { useEffect } from "react";
import Footer from "@/layout/Footer";
import Header from "@/layout/header";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import loadable from '@loadable/component';
import Clarity from "@/component/shared/clarity";
import {DownloadStripProvider} from "@/layout/downloadStripContext"
import CleverTap from "@/lib/clevertap";
import CleverTapNotifications from "@/component/shared/cleverTapNotifications";
import CalendlyBadge from "@/component/shared/CalendlyBadge";
import { GA_TAG } from "@/config/endpoints";
import GoogleAnalytics from "@/component/shared/GA";
const DynamicGoogleAds = loadable(() => import('@/component/shared/googleAds'));
const FaceBookMeta = loadable(() => import('@/component/shared/fb'));
import Head from "next/head";

const SITE_MAP_KEY = process.env.SITE_KEY;

export default function App({ Component, pageProps }) {
  // const router = useRouter();

  useEffect(() => {
    const isProductionURL = window.location.href.startsWith('https://www.credlix.com/blogs');

    
    if (typeof window !== "undefined" && isProductionURL) {
      // Disable right-click
      const disableRightClick = (event) => event.preventDefault();
      document.addEventListener('contextmenu', disableRightClick);

      // Disable copy, cut, and text selection
      const disableCopyCut = (event) => event.preventDefault();
      document.addEventListener('copy', disableCopyCut);
      document.addEventListener('cut', disableCopyCut);
      document.addEventListener('selectstart', disableCopyCut);

      // Disable screenshot key combinations
      const disableKeydown = (event) => {
        if (event.key === "PrintScreen") {
          event.preventDefault();
        }
        if (event.ctrlKey && event.shiftKey && event.key === 'S') {
          event.preventDefault();
        }

       
        if (
          (event.ctrlKey && event.shiftKey && event.key === 'I') || 
          (event.ctrlKey && event.shiftKey && event.key === 'C') ||
          (event.key === 'F12') || 
          (event.metaKey && event.altKey && event.key === 'I') ||  
          (event.metaKey && event.altKey && event.key === 'C') ||   
          (event.shiftKey && event.key === "PrintScreen") || 
          (event.shiftKey && event.key === "PrintScreen" && event.getModifierState('Fn'))
        ) {
          event.preventDefault();
        }
      };
      document.addEventListener('keydown', disableKeydown);

      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js')
          .then((registration) => {
            console.log('Service Worker registered with scope:', registration.scope);
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });
      }

      return () => {
        document.removeEventListener('contextmenu', disableRightClick);
        document.removeEventListener('copy', disableCopyCut);
        document.removeEventListener('cut', disableCopyCut);
        document.removeEventListener('selectstart', disableCopyCut);
        document.removeEventListener('keydown', disableKeydown);
      };
    }
  }, []);


  return (
    <>
      <DownloadStripProvider>
      <GoogleReCaptchaProvider
          reCaptchaKey={SITE_MAP_KEY}
          scriptProps={{
            async: true,
            defer: true,
            appendTo: "head",
            nonce: undefined,
          }}
        >
      <CleverTap />
      <CleverTapNotifications />
      <Header />

         <FaceBookMeta />
         <div className="lg:-mt-3">
         <Component {...pageProps} /> 
         </div>
        <Footer />
        <DynamicGoogleAds />
        {GA_TAG && <GoogleAnalytics ga_id={GA_TAG} />}
        
        </GoogleReCaptchaProvider>
         
        <Clarity/>
        <CalendlyBadge />
        </DownloadStripProvider>
    </>
  );
}
